export class ChangeAttributes {
    constructor() {
        this.hours = [];
        this.hid = true;
        this.voucherhid = true;
    }
}
